(function () {
  var html = document.documentElement;
  var KEY = 'cdSide';

  function wide() { return window.matchMedia('(min-width: 750px)').matches; }
  function isOpen() { return html.classList.contains('cd-side-open'); }
  function store(v) { try { sessionStorage.setItem(KEY, v); } catch (e) {} }

  // Move the menu pieces to <body> and drop stale copies from earlier renders
  var fresh = document.querySelector('.cd-root:not([data-cd-moved])');
  if (fresh) {
    document.querySelectorAll('body > .cd-root[data-cd-moved]').forEach(function (old) { old.remove(); });
    fresh.setAttribute('data-cd-moved', '');
    document.body.appendChild(fresh);
  }

  // Home never shows the left bar on PC
  if (document.querySelector('.dd-hero') && wide()) html.classList.remove('cd-side-open');

  function onScroll() {
    var root = document.querySelector('.cd-root');
    if (root) root.classList.toggle('is-scrolled', window.scrollY > 40);
  }
  onScroll();

  if (window.__cdMenuBound) return;
  window.__cdMenuBound = true;
  window.addEventListener('scroll', onScroll, { passive: true });

  // Cart: light red while it has items, and a pulse each time the count changes
  var cart = document.querySelector('.cd-cart');
  if (cart) {
    var syncCart = function () {
      cart.classList.toggle('has-items', !!cart.querySelector('.cd-cart__count'));
    };
    var pulseTimer;
    syncCart();
    new MutationObserver(function () {
      syncCart();
      cart.classList.remove('is-pulse');
      void cart.offsetWidth;
      cart.classList.add('is-pulse');
      clearTimeout(pulseTimer);
      pulseTimer = setTimeout(function () { cart.classList.remove('is-pulse'); }, 1000);
    }).observe(cart, { childList: true, subtree: true, characterData: true });
  }

  // The header logo glides in from where the left bar logo was
  function flyLogo(from) {
    var target = null;
    document.querySelectorAll('.cd-logo img').forEach(function (img) {
      if (!target && img.offsetWidth > 0) target = img;
    });
    if (!target) return;
    var to = target.getBoundingClientRect();
    if (!to.width) return;

    var dx = (from.left + from.width / 2) - (to.left + to.width / 2);
    var dy = (from.top + from.height / 2) - (to.top + to.height / 2);
    var s = from.width / to.width;

    target.style.transition = 'none';
    target.style.transformOrigin = 'center center';
    target.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + s + ')';
    target.getBoundingClientRect();
    target.style.transition = 'transform .7s cubic-bezier(.65, 0, .2, 1)';
    target.style.transform = '';
    setTimeout(function () {
      target.style.transition = '';
      target.style.transformOrigin = '';
    }, 800);
  }

  function setOpen(open, byUser) {
    if (open === isOpen()) return;

    var sideLogo = document.querySelector('.cd-drawer__logo');
    var sideImg = document.querySelector('.cd-drawer__logo-img');
    var from = (!open && wide() && sideImg) ? sideImg.getBoundingClientRect() : null;

    html.classList.toggle('cd-side-open', open);

    var burger = document.querySelector('.cd-burger');
    if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (byUser) store(open ? 'open' : 'closed');
    window.dispatchEvent(new Event('cd:toggle'));

    if (sideLogo) {
      if (from) sideLogo.style.opacity = '0';
      setTimeout(function () { sideLogo.style.opacity = ''; }, 800);
    }
    if (from && from.width) flyLogo(from);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.dd-shop')) { store('open'); return; }
    if (e.target.closest('.cd-burger')) { setOpen(!isOpen(), true); return; }
    if (e.target.closest('.cd-drawer__close')) { setOpen(false, true); return; }
    if (e.target.closest('.cd-overlay')) { setOpen(false, true); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen() && !wide()) setOpen(false, true);
  });
})();